import { Popover, Box, Typography } from "@mui/material";
import { filterOptionStyles } from "../styles/filterOptionStyles";
import { useSelector } from "react-redux";
import { preDefinedAttributesTextField } from "../../sidebar-bot/utils/preDefinedAttribuesTextField";
import { getRandomId } from "../../utils";

const styles = filterOptionStyles;

const FilterOptionsPopover = ({
  optionsAnchorEl,
  setOptionsAnchorEl,
  setCondValAnchorEl,
  handleClosePopover,
  fltrObj,
  targetDivRef,
  index,
  setFilters,
}) => {
  const open = optionsAnchorEl?.openedPopoverId === fltrObj?.id;
  const id = open ? "simple-popover" : undefined;
  const globalAttributes = useSelector((state) => state.flow?.globalAttributes);

  const handleOptionClick = (e, type) => {
    fltrObj.attribute = type;
    setOptionsAnchorEl({ openedPopoverId: null, anchorEl: null });
    setCondValAnchorEl({
      openedPopoverId: fltrObj?.id,
      anchorEl: targetDivRef?.current,
    });
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={optionsAnchorEl.anchorEl}
      onClose={handleClosePopover}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
    >
      <Box sx={styles.outerBox}>
        <Box
          sx={{
            ...styles.innerBox,
            "&:hover": {
              backgroundColor: "#fff",
            },
          }}
        >
          <Typography variant="h6" sx={styles.mainTitle}>
            PRE-DEFINED ATTRIBUTES
          </Typography>
        </Box>
        {preDefinedAttributesTextField.length > 0 &&
          preDefinedAttributesTextField.map((attribute, index) => (
            <Box
              key={index}
              sx={styles.innerBox}
              onClick={(e) => handleOptionClick(e, attribute)}
            >
              <Typography variant="span" sx={styles.innerBoxTitle}>
                {attribute}
              </Typography>
            </Box>
          ))}
        <Box
          sx={{
            ...styles.innerBox,
            "&:hover": {
              backgroundColor: "#fff",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{ ...styles.mainTitle, marginTop: "10px" }}
          >
            CUSTOM ATTRIBUTES
          </Typography>
        </Box>

        {globalAttributes.length > 0 &&
          globalAttributes.map((attribute, index) => (
            <Box
              key={index}
              sx={styles.innerBox}
              onClick={(e) => handleOptionClick(e, attribute)}
            >
              <Typography variant="span" sx={styles.innerBoxTitle}>
                {attribute}
              </Typography>
            </Box>
          ))}
      </Box>
    </Popover>
  );
};

export default FilterOptionsPopover;
